import React from 'react'
import { Controller } from 'react-hook-form'

import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

import CustomCheckbox from 'components/CustomCheckbox'
import CustomSelect from 'components/CustomSelect'
import CustomTextField from 'components/CustomTextField'
import { OptionalFormType } from 'hooks/useEvent'

export default function OptionalForm({ register, control, id, field, error }) {
  const { spacing } = useTheme()

  switch (field.type) {
    case OptionalFormType.Text:
      return (
        <CustomTextField
          id={id}
          label={field.label}
          placeholder={field.item}
          register={register(id, { required: field.required, maxLength: 100 })}
          error={Boolean(error) && { message: '100文字以内で入力して下さい' }}
          helperText={field.attention}
        />
      )
    case OptionalFormType.Checkbox:
      return (
        <CustomCheckbox
          id={id}
          control={control}
          required={field.required}
          label={field.label}
          options={field.item}
          error={error}
          helperText={field.attention}
        />
      )
    case OptionalFormType.Radio:
      return (
        <div style={{ padding: spacing(2, 0) }}>
          <FormControl>
            <Typography variant="caption" color={error === undefined ? 'textSecondary' : 'error'}>
              {field.label}
            </Typography>
            <Controller
              render={({ field: controllerField }) => (
                <RadioGroup {...controllerField} name="gender1">
                  {field.item.map(({ label, value }) => (
                    <FormControlLabel key={value} value={value} control={<Radio />} label={label} />
                  ))}
                </RadioGroup>
              )}
              defaultValue=""
              control={control}
              name={id}
              rules={{ required: field.required }}
            />
            {Boolean(field.attention) && <FormHelperText>{field.attention}</FormHelperText>}
            {error && <FormHelperText error>必須項目です</FormHelperText>}
          </FormControl>
        </div>
      )
    case OptionalFormType.Select:
      return (
        <CustomSelect
          id={id}
          label={field.label}
          control={control}
          rules={{ required: field.required }}
          options={field.item}
          helperText={field.attention}
          error={error}
        />
      )
    default:
      return null
  }
}
